module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("The splendor falls on castle walls "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _vm._v("And snowy summits old in story: "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _vm._v("The long light shakes across the lakes, "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _vm._v("And the wild cataract leaps in glory. "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _vm._v("Blow, bugle, blow, set the wild echoes flying, "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _vm._v("Blow, bugle; answer, echoes, dying, dying, dying. "), _c('span', {
    staticClass: "s1"
  }, [_c('br'), _c('br')]), _c('span', {
    staticClass: "Apple-converted-space"
  }), _vm._v("—Tennyson")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('b')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133fe847","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 75
// module chunks = 0